import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import Swal from 'sweetalert2';
import { svgIconList } from '@shared/svg-icon-list';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-widget',
  imports: [CommonModule, RouterLink],
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss']
})
export class WidgetComponent implements OnInit, OnChanges {

  @Input()
  widgetData: any;

  @Input() closeWidgetCount: number;
  @Output() closeWidgetCountChange = new EventEmitter<any>(); 

  widget:any;
  svg: any = svgIconList;

  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['widgetData'] && changes['widgetData'].currentValue) {
    this.widget = changes['widgetData'].currentValue;
  }
  }

  updateWidgetData(newData: number) {
    if(this.closeWidgetCount === undefined){
      this.closeWidgetCount = 0;
    }
    this.closeWidgetCount += newData;
    //pass counter to appcomponent
    this.closeWidgetCountChange.emit(this.closeWidgetCount);
  }

  onCloseWidget(event:any){
    const element = event.target.parentNode;
    element.style.display = 'none';
    this.updateWidgetData(1);
  }

  
  onClickWidget(message:string) {
    Swal.fire({
      html: `<div class="alert-svg">${this.svg.alertIcon}</div>` +
            '<div class="text-center m-t-20">' +
              `<ul><li>` + message + `</li></ul>` +
            '</div>',
      showCloseButton: true,
      showConfirmButton: false,
    });
  }
}
